<template>
    <div>
        <template v-if="crud_company === true ">
            <div class="page-top mb-1 mb-3">
                <h1> Edit Company </h1>
            </div>
            <div class="global-main p-0">
                <div class="onboarding-form-outer">
                    <div class="onboarding-main">
                        <div class="container">
                            <div class="onboarding-top-steps">
                                <ul class="clearfix onb-steps-list">
                                    <li> <span class="counter"> 1 </span> Company Details </li>
                                    <li> <span class="counter"> 2 </span> Required Documents </li>
                                    <li> <span class="counter"> 3 </span> CNIC Details </li>
                                </ul>
                            </div>
                            <div class="onboarding-form mt-0">
                                <form id="companyForm" @submit.prevent="updateCompanyData">
                                <div class="tab-content-inner">
                                    <div v-if="companies.length > 0">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group" :class="{ 'm-0': readonly_fields==1 }">
                                                    <label class="mb-0">Company Account Type<em class="required">*</em></label>
                                                    <select v-model="form.company_account_type" name="company_account_type" id="company_account_type" class="selectpicker custom-select2  p-0 form-control" :class="{ 'is-invalid': form.errors.has('company_account_type') }" @change="companyAccountTypeChange()">
                                                        <option value="VIRTUAL">Virtual</option>
                                                        <option value="CORPORATE">Corporate</option>
                                                    </select>
                                                    <has-error :form="form" field="company_account_type"></has-error>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label class="mb-0">Associate Company</label>
                                                    <select v-model="form.parent_company" name="companies" data-live-search="true" class="selectpicker custom-select2  p-0 form-control" >
                                                        <option value="" selected>Select Parent Company</option>
                                                            <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">
                                                                {{ company.name }}
                                                            </option>
                                                    </select>
                                                    <has-error :form="form" field="parent_company"></has-error>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label class="mb-0">Payment Engine <em class="required">*</em></label>
                                                    <select v-model="form.payment_engine" name="payment_engine" id="payment_engine" class="selectpicker custom-select2  p-0 form-control" :class="{ 'is-invalid': form.errors.has('payment_engine') }" @change="paymentEngineChange()">
                                                        <option value="" selected>Select Payment Engine</option>
                                                        <option value="FINCA">Finca Microfinance Bank</option>
                                                        <option v-show="form.company_account_type == 'VIRTUAL'" value="MEEZAN">Meezan Bank</option>
                                                        <option v-show="form.company_account_type == 'CORPORATE'" value="EMONEY">EMONEY</option>
                                                        <!-- <option value="EASY_PAISA">Easy Paisa</option> -->
                                                        <!-- <option value="NBP_FUND">NBP Funds</option>
                                                        <option value="FAYSAL">Faysal Bank</option> -->
                                                    </select>
                                                    <has-error :form="form" field="payment_engine"></has-error>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <input v-model="form.companyName" type="text" 
                                            name="companyName" class="form-control" autocomplete="off" maxlength="50" :class="{ 'is-invalid': form.errors.has('companyName') }" placeholder="Company Name" required :readonly="readonly_fields==1">
                                        <label for="companyName" class="absolute-label">Company Name <em class="required">*</em></label>
                                        <has-error :form="form" field="companyName"></has-error>
                                    </div>
                                    <div class="form-group">
                                        <label class="mb-0"> Type of industry </label>
                                        <select v-model="form.industryType" data-live-search="true" name="industryType" class="selectpicker custom-select2  p-0 form-control" :class="{ 'is-invalid': form.errors.has('industryType') }" :disabled="readonly_fields==1">
                                                <option v-for="industry_type in industry_types" v-bind:value="industry_type.id" v-bind:key="industry_type.id">
                                                    {{ industry_type.name }}
                                                </option>
                                        </select>
                                        <has-error :form="form" field="industryType"></has-error>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input v-model="form.companySize" type="number" min="0" maxlength="15" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); validity.valid||(value='');" 
                                                    name="companySize" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('companySize') }" placeholder="Size of Company" required :readonly="readonly_fields==1">
                                                <label for="companySize" class="absolute-label">Size of Company <em class="required">*</em></label>
                                                <has-error :form="form" field="companySize"></has-error>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input v-model="form.monthlyThroughput" type="number" min="0" maxlength="15" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); validity.valid||(value='');" 
                                                    name="monthlyThroughput" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('monthlyThroughput') }" placeholder="Monthly Throughput" required :readonly="readonly_fields==1">
                                                <label for="monthlyThroughput" class="absolute-label">Monthly Throughput <em class="required">*</em></label>
                                                <has-error :form="form" field="monthlyThroughput"></has-error>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input v-model="form.monthlySales" type="number" min="0" maxlength="15" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); validity.valid||(value='');" 
                                                    name="monthlySales" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('monthlySales') }" placeholder="Monthly Sales" required :readonly="readonly_fields==1">
                                                <label for="monthlySales" class="absolute-label">Monthly Sales <em class="required">*</em></label>
                                                <has-error :form="form" field="monthlySales"></has-error>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <datepicker :disabledDates="disabledDatesTo" v-model="form.yearOfIncorporation" :minimumView="'year'" :maximumView="'year'" input-class="datepicker" :bootstrap-styling="true" :clear-button="true" placeholder="Select Year Of Incorporation" name="yearOfIncorporation" :class="{ 'is-invalid': form.errors.has('yearOfIncorporation') }" :disabled="readonly_fields==1"></datepicker>
                                                <label for="yearOfIncorporation" class="absolute-label">Year Of Incorporation <em class="required">*</em></label>
                                                <has-error :form="form" field="yearOfIncorporation"></has-error>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group" :class="{ 'm-0': readonly_fields==1 }">
                                                <input v-model="form.companyEmailAddress" type="email" 
                                                    name="companyEmailAddress" class="form-control" autocomplete="off" maxlength="40" :class="{ 'is-invalid': form.errors.has('companyEmailAddress') }" placeholder="Company Email Address" required :readonly="readonly_fields==1">
                                                <label for="companyEmailAddress" :class="[readonly_fields==1 ? 'active_absolute_label' : 'absolute-label']">Company Email Address <em class="required">*</em></label>
                                                <has-error :form="form" field="companyEmailAddress"></has-error>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group" :class="{ 'm-0': readonly_fields==1 }">
                                                <input v-model="form.companyMobileNumber" type="number" min="0" maxlength="13" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); validity.valid||(value='');" 
                                                    name="companyMobileNumber" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('companyMobileNumber') }" placeholder="Company Mobile Number" required :readonly="readonly_fields==1">
                                                <label for="companyMobileNumber" :class="[readonly_fields==1 ? 'active_absolute_label' : 'absolute-label']">Company Mobile Number <em class="required">*</em></label>
                                                <has-error :form="form" field="companyMobileNumber"></has-error>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <input v-model="form.companyAddress" type="text" 
                                            name="companyAddress" class="form-control" autocomplete="off" maxlength="100" :class="{ 'is-invalid': form.errors.has('companyAddress') }" placeholder="Company Address" required :readonly="readonly_fields==1">
                                        <label for="companyAddress" class="absolute-label">Company Address <em class="required">*</em></label>
                                        <has-error :form="form" field="companyAddress"></has-error>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6 mt-4">
                                            <div class="form-group">
                                                <input v-model="form.postal_code" type="number" min="0" maxlength="10" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); validity.valid||(value='');" 
                                                    name="postal_code" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('postal_code') }" placeholder="Postal Code" required :readonly="readonly_fields==1">
                                                <label for="postal_code" class="absolute-label">Postal Code <em class="required">*</em></label>
                                                <has-error :form="form" field="postal_code"></has-error>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="mb-0">Company Type</label>
                                                <select v-model="form.companyType" name="companyType" class="selectpicker custom-select2  p-0 form-control" :class="{ 'is-invalid': form.errors.has('companyType') }" :disabled="readonly_fields==1">
                                                    <option value="PAYROLL">Default</option>
                                                    <option value="MERCHANT">Merchant</option>  
                                                </select>
                                                <has-error :form="form" field="companyType"></has-error>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="companies.length > 0">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <input v-model="form.walletID" type="number" min="0" maxlength="15" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); validity.valid||(value='');" 
                                                        name="walletID" id="walletID" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('walletID') }" placeholder="Wallet Id" >
                                                    <label for="walletID" class="absolute-label" id="wallet-id-label">Wallet Id</label>
                                                    <has-error :form="form" field="walletID"></has-error>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <input v-model="form.ntn" type="text" min="0" maxlength="15" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); validity.valid||(value='');" 
                                                        name="ntn" id="ntn" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('ntn') }" placeholder="NTN" >
                                                    <label for="ntn" class="absolute-label" id="ntn-label">NTN</label>
                                                    <has-error :form="form" field="ntn"></has-error>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="mb-0"> Select Country </label>
                                                <select v-model="form.approverCountry" data-live-search="true" name="approverCountry" class="selectpicker custom-select2  p-0 form-control" :class="{ 'is-invalid': form.errors.has('approverCountry') }" :disabled="readonly_fields==1">
                                                        <option v-for="country in countries" v-if="country.name=='Pakistan'" v-bind:value="country.id" v-bind:key="country.id">
                                                            {{ country.name }}
                                                        </option>
                                                </select>
                                                <has-error :form="form" field="approverCountry"></has-error>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="mb-0"> Select City </label>
                                                <select v-model="form.city" data-live-search="true" name="city" class="selectpicker custom-select2  p-0 form-control" :class="{ 'is-invalid': form.errors.has('city') }" :disabled="readonly_fields==1">
                                                        <option v-for="city in cities" v-bind:value="city.id" v-bind:key="city.id">
                                                            {{ city.name }}
                                                        </option>
                                                </select>
                                                <has-error :form="form" field="city"></has-error>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="label block-label"> Account Type <em class="required">*</em></label>
                                                <select v-model="form.account_type" @change="selectPickerOnchange()" required data-live-search="true" name="account_type" class="selectpicker custom-select2 p-0" :class="{ 'is-invalid': form.errors.has('account_type') }">
                                                    <option v-for="accountType in accountTypes" v-bind:value="accountType.id" v-bind:key="accountType.id">
                                                        {{ accountType.type }}
                                                    </option>
                                                </select>
                                                <has-error :form="form" field="account_type"></has-error>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="label block-label"> Purpose of Account <em class="required">*</em></label>
                                                <select class="custom-select" v-model="form.purposeOfAccount" name="purposeOfAccount" required>
                                                    <option value="">Purpose Of account *</option>
                                                    <option value="Collection">Collection</option>
                                                    <option value="HRMS System">HRMS System</option>
                                                    <option value="Payment Disbursement">Payment Disbursement</option>
                                                    <option value="All">All</option>
                                                </select>
                                                <has-error :form="form" field="purposeOfAccount"></has-error>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input id="numberOfVendors"
                                                       type="number" min="0" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); validity.valid||(value='');"
                                                       class="form-control"
                                                       v-model="form.numberOfVendors"
                                                       name="numberOfVendors" placeholder="Number of Vendors for payments *"
                                                       required maxlength="9">
                                                <label for="numberOfVendors" class="absolute-label">Number of Vendors for payments <em
                                                        class="required">*</em></label>
                                                <has-error :form="form" field="numberOfVendors"></has-error>
                                            </div>
                                        </div>

                                    </div>
                                    <div v-if="companies.length > 0">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label class="mb-0"> POC <em class="required">*</em></label>
                                                    <select v-model="form.poc_id" data-live-search="true" name="poc_id" class="selectpicker custom-select2  p-0 form-control" :class="{ 'is-invalid': form.errors.has('poc_id') }" v-if="pocs != null">
                                                        <option value="" selected>Select POC</option>
                                                        <option v-for="poc in pocs" v-bind:value="poc.id" v-bind:key="poc.id">
                                                            {{ poc.name }}
                                                        </option>
                                                    </select>
                                                    <has-error :form="form" field="poc_id"></has-error>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label class="mb-0"> On Board <em class="required">*</em></label>

                                                  <select v-model="form.on_board" name="on_board" data-live-search="true" class="selectpicker custom-select2  p-0 form-control" :class="{ 'is-invalid': form.errors.has('on_board') }">
                                                    <option v-for="onboardSource in listOnboardSouces" v-bind:value="onboardSource.code" v-bind:key="onboardSource.code">
                                                      {{ onboardSource.name }}
                                                    </option>
                                                  </select>
                                                    <has-error :form="form" field="on_board"></has-error>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="mb-0">Invoice Discounting</label>
                                            <select v-model="form.invoice_discounting" name="invoice_discounting" class="selectpicker custom-select2  p-0 form-control" :class="{ 'is-invalid': form.errors.has('invoice_discounting') }" :disabled="readonly_fields==1">
                                                <option value="SET_NOW" selected>SET NOW</option>
                                                <option value="ENABLED">ENABLED</option>
                                                <option value="DISABLED">DISABLED</option> 
                                            </select>
                                            <has-error :form="form" field="invoice_discounting"></has-error>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input v-model="form.approverName" type="text" 
                                                    name="approverName" class="form-control" autocomplete="off" maxlength="50" :class="{ 'is-invalid': form.errors.has('approverName') }" placeholder="Approver/Account Holder Name" required :readonly="readonly_fields==1">
                                                <label for="approverName" class="absolute-label">Approver/Account Holder Name <em class="required">*</em></label>
                                                <has-error :form="form" field="approverName"></has-error>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input id="fatherName" type="text"
                                                       class="form-control"
                                                       v-model="form.fatherName"
                                                       placeholder="Approver/Account Holder Father Name *"
                                                       required maxlength="100">
                                                <label for="fatherName" class="absolute-label">Approver/Account Holder Father Name <em
                                                        class="required">*</em></label>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input id="motherName" type="text"
                                                       class="form-control"
                                                       v-model="form.motherName" placeholder="Approver/Account Holder Mother Name *"
                                                       required maxlength="100">
                                                <label for="motherName" class="absolute-label">Approver/Account Holder Mother Name <em
                                                        class="required">*</em></label>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <select v-model="form.approverGender" name="approverGender" class="selectpicker custom-select2  p-0 form-control" :class="{ 'is-invalid': form.errors.has('approverGender') }" :disabled="readonly_fields==1">
                                                    <option value="" selected>Select Gender</option>
                                                    <option value="MALE">Male</option>
                                                    <option value="FEMALE">Female</option>
                                                    <option value="NONE">Other</option>
                                                </select>
                                                <has-error :form="form" field="approverGender"></has-error>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <datepicker name="from_date"
                                                            v-model="form.approverDob"
                                                            input-class="datepicker"
                                                            :bootstrap-styling="true"
                                                            :required="true"
                                                            placeholder="Approver/Account Holder Date of Birth *"
                                                >
                                                </datepicker>
                                                <label for="" class="absolute-label">Approver/Account Holder Date of Birth <em class="required">*</em></label>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input id="placeOfBirth" type="text"
                                                       class="form-control"
                                                       v-model="form.placeOfBirth"
                                                       placeholder="Approver/Account Holder Place of birth *"
                                                       required
                                                       maxlength="40">
                                                <label for="placeOfBirth" class="absolute-label">Approver/Account Holder Place of birth <em
                                                        class="required">*</em></label>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input v-model="form.approverEmailAddress" type="email" 
                                                    name="approverEmailAddress" class="form-control" autocomplete="off" maxlength="40" :class="{ 'is-invalid': form.errors.has('approverEmailAddress') }" placeholder="Approver/Account Holder Email Address" required :readonly="readonly_fields==1">
                                                <label for="approverEmailAddress" class="absolute-label">Approver/Account Holder Email Address <em class="required">*</em></label>
                                                <has-error :form="form" field="approverEmailAddress"></has-error>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input v-model="form.approverCNIC" type="number" min="0" maxlength="13" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); validity.valid||(value='');"
                                                       name="approverCNIC" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('approverCNIC') }" placeholder="Approver/Account Holder CNIC Number (Without dashes)" required :readonly="readonly_fields==1">
                                                <label for="approverCNIC" class="absolute-label">Approver/Account Holder CNIC Number <small>(Without dashes)</small> <em class="required">*</em></label>
                                                <has-error :form="form" field="approverCNIC"></has-error>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">

                                        <div class="col-md-6">
                                            <div class="form-group">
<!--                                                <input id="cnicIssuance" type="text"-->
<!--                                                       class="form-control"-->
<!--                                                       v-model="form.cnicIssuance" placeholder="Approver/Account Holder Date of CNIC Issuance *"-->
<!--                                                       required maxlength="10">-->
                                                <label class="mb-0">Approver/Account Holder Date of CNIC Issuance *</label>
                                                <datepicker name="cnicIssuance"
                                                            v-model="form.cnicIssuance"
                                                            input-class="datepicker"
                                                            :bootstrap-styling="true"
                                                            id="cnicIssuance"
                                                            :required="true"
                                                            placeholder="Approver/Account Holder Date of CNIC Issuance *">
                                                </datepicker>
                                                <label for="cnicIssuance" class="absolute-label">Approver/Account Holder Date of CNIC Issuance <em
                                                        class="required">*</em></label>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="mb-0">Approver/Account Holder Date of CNIC Expiry *</label>
                                                <datepicker name="cnicExpiry"
                                                            v-model="form.cnicExpiry"
                                                            input-class="datepicker"
                                                            :bootstrap-styling="true"
                                                            :required="true"
                                                            placeholder="Approver/Account Holder Date of CNIC Expiry *">
                                                </datepicker>
                                                <label for="cnicExpiry" class="absolute-label">Approver/Account Holder Date of CNIC Expiry <em
                                                        class="required">*</em></label>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input v-model="form.approverMobileNumber" type="number" min="0" maxlength="13" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); validity.valid||(value='');"
                                                       name="approverMobileNumber" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('approverMobileNumber') }" placeholder="Approver/Account Holder Mobile Number" required :readonly="readonly_fields==1">
                                                <label for="approverMobileNumber" class="absolute-label">Approver/Account Holder Mobile Number <em class="required">*</em></label>
                                                <has-error :form="form" field="approverMobileNumber"></has-error>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input id="approverMailingAddress" type="text"
                                                       class="form-control"
                                                       v-model="form.approverMailingAddress"
                                                       placeholder="Approver/Account Holder Mailing Address *"
                                                       required
                                                       maxlength="100">
                                                <label for="approverMailingAddress" class="absolute-label">Approver/Account Holder Mailing Address <em class="required">*</em></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <button v-if="readonly_fields==0" :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                                    <router-link v-if="readonly_fields==1" :to="{path: '/companyDocuments/' + companyId}" class="btn btn-primary float-right active">Next</router-link>
                                    <router-link to="/allCompanies" class="btn btn-primary float-right mr-2">Cancel</router-link>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="crud_company === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_company === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                form: new Form({
                    fromWeb: 1,
                    company_account_type: '',
                    payment_engine: '',
                    parent_company: '',
                    companyName: '',
                    industryType: '',
                    companySize: '',
                    monthlyThroughput: '',
                    monthlySales: '',
                    yearOfIncorporation: '',
                    companyEmailAddress: '',
                    companyMobileNumber: '',
                    companyAddress: '',
                    approverCountry: '',
                    city: '',
                    approverName: '',
                    approverEmailAddress: '',
                    approverMobileNumber: '',
                    approverCNIC: '',
                    approverGender: '',
                    approverYob: '',
                    companyType: '',
                    postal_code: '',
                    on_board: '',
                    poc_id: '',
                    walletID: '',
                    ntn: '',
                    invoice_discounting: '',
                    account_type: '',
                    purposeOfAccount: '',
                    numberOfVendors: '',
                    fatherName: '',
                    motherName: '',
                    cnicIssuance: '',
                    cnicExpiry: '',
                    placeOfBirth: '',
                    approverMailingAddress: '',
                    approverDob: ''
                    }),
                listOnboardSouces: [],
                cities: [],
                companies:[],
                countries:[],
                industry_types:[],
                pocs: null,
                crud_company: null,
                companyId: '',
                readonly_fields: 0,
                company_details: [],
                show_admin_fields: false,
                disabledDatesTo:{
                    from: new Date(),
                    to: new Date('1900-01-01')
                },
                accountTypes: [],
            }
        },
        methods: {
            updateCompanyData() {
                this.$Progress.start();
                this.form.post('/apiV2/digitalOnboarding/updateCompanyData')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Company updated successfully');
                        this.$router.push('/editOnboardedCompanyDocuments/'+res.data.data.company_id);
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(error => {
                    var error_msg = '';

                    error_msg = 'Please provide following details:'+'\n';     

                    $.each(error.response.data.errors, (key, value) => {
                        error_msg += value +'\n';     
                    });
                    this.$Progress.fail();
                    this.showAlertBox('error',error_msg);
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                });
            },
          getOnboardSources(){
                this.$Progress.start();
                var url = '/api/listOnboardSources';

                axios.get(url)
                .then(res => {
                    if(res.status == 200){
                        this.listOnboardSouces=res.data.data;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','No data found');
                    }
                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load form data');
                });
            },
            getOnboardingCompanyPreData(){
                this.$Progress.start();
                if(typeof(this.$route.params.id) != "undefined" && this.$route.params.id !== null) {
                    var url = '/apiV2/digitalOnboarding/getOnboardingPreData/'+this.$route.params.id;
                } else {
                    var url = '/apiV2/digitalOnboarding/getOnboardingPreData/0';
                }
                axios.get(url)
                .then(res => {
                    if(res.status == 200){
                        this.cities = res.data.data.cities;
                        this.industry_types = res.data.data.industry_types;
                        this.countries = res.data.data.countries;
                        if(typeof(res.data.data.pocs) != "undefined" && res.data.data.pocs !== null) {
                            this.pocs = res.data.data.pocs;
                            this.companies = res.data.data.companies;
                            this.show_admin_fields = true;
                        }
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load form data');
                });
            },
            getOnboardUserDetails(){
                axios.post('/apiV2/digitalOnboarding/getOnboardingUserDetails',{companyId:this.companyId})
                .then(res => {
                    if(res.status == 200){
                        if ( res.data.code == 200 ) {
                            const companyExtension = res.data.data.company_extension;
                            this.company_details = res.data.data.company[0];
                            this.form.company_account_type = this.company_details.company_vrCorporate == 'YES' ? 'VIRTUAL' : 'CORPORATE';
                            this.form.payment_engine = this.company_details.payment_engine;
                            this.companyAccountTypeChange();
                            this.form.companyName = this.company_details.company_name;
                            this.form.industryType = this.company_details.company_industry_type;
                            this.form.companySize = this.company_details.company_company_size;
                            this.form.monthlyThroughput = this.company_details.company_monthly_throughput;
                            this.form.monthlySales = this.company_details.company_monthly_sales;
                            this.form.yearOfIncorporation = '01 Jan '+this.company_details.company_year_of_incorporation;
                            this.form.companyEmailAddress = this.company_details.company_email;
                            this.form.companyMobileNumber = this.company_details.company_phone;
                            this.form.companyAddress = this.company_details.company_address_1;
                            this.form.approverCountry = this.company_details.company_country_id;
                            this.form.city = this.company_details.company_city_id;
                            this.form.approverName = this.company_details.user_name;
                            this.form.approverEmailAddress = this.company_details.user_email;
                            this.form.approverMobileNumber = this.company_details.user_mobile_no;
                            this.form.approverCNIC = this.company_details.user_cnic;
                            this.form.approverGender = this.company_details.user_gender;
                            this.form.approverYob = '01 Jan '+this.company_details.user_yob;
                            this.form.companyType = this.company_details.companyType;
                            this.form.parent_company = this.company_details.parent_company;
                            this.form.postal_code = this.company_details.postal_code;
                            this.form.on_board = this.company_details.on_board;
                            this.form.poc_id = this.company_details.poc_id;
                            this.form.walletID = this.company_details.walletID;
                            this.form.ntn = this.company_details.ntn;
                            this.form.invoice_discounting = this.company_details.invoice_discounting;
                            this.readonly_fields = 0;

                            if (companyExtension) {
                                this.form.account_type = companyExtension.account_type_id;
                                this.form.purposeOfAccount = companyExtension.purpose_of_account;
                                this.form.numberOfVendors = companyExtension.number_of_vendors;
                            }
                            this.form.fatherName = this.company_details.father_name;
                            this.form.motherName = this.company_details.mother_name;
                            this.form.cnicIssuance = this.company_details.cnic_issuance;
                            this.form.cnicExpiry = this.company_details.cnic_expiry;
                            this.form.placeOfBirth = this.company_details.place_of_birth;
                            this.form.approverMailingAddress = this.company_details.mailing_address;
                            this.form.approverDob = this.company_details.dob;
                        } else {
                            this.showAlertBox('error','Error to load data');
                        }
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            companyAccountTypeChange() {
                if(this.form.company_account_type == 'VIRTUAL') {
                    $("#payment_engine").append(new Option("Emoney", "EMONEY"));
                    $("#payment_engine option[value='MEEZAN']").remove();
                    $('#walletID').prop('required',false);
                        $('#wallet-id-label').html('Wallet ID');
                        $('#walletID').attr("placeholder", "Wallet ID");
                    $('#ntn').prop('required',false);
                        $('#ntn-label').html('NTN');
                        $('#ntn').attr("placeholder", "NTN");
                } else if(this.form.company_account_type == 'CORPORATE') {
                    $("#payment_engine").append(new Option("Meezan Bank", "MEEZAN"));
                    $("#payment_engine option[value='EMONEY']").remove();
                    if(this.form.payment_engine == 'FINCA') {
                        $('#ntn').prop('required',false);
                            $('#ntn-label').html('NTN');
                            $('#ntn').attr("placeholder", "NTN");
                        $('#walletID').prop('required',true);
                        $('#wallet-id-label').html('Wallet ID *');
                        $('#walletID').attr("placeholder", "Wallet ID *");
                    } 
                } else {
                    $("#payment_engine option[value='MEEZAN']").remove();
                    $("#payment_engine option[value='EMONEY']").remove();
                    $('#walletID').prop('required',false);
                        $('#wallet-id-label').html('Wallet ID');
                        $('#walletID').attr("placeholder", "Wallet ID");
                    $('#ntn').prop('required',false);
                        $('#ntn-label').html('NTN');
                        $('#ntn').attr("placeholder", "NTN");
                }
                $('#payment_engine').selectpicker('refresh');
            },
            paymentEngineChange() {
                if(this.form.company_account_type == 'VIRTUAL') {
                    $('#walletID').prop('required',false);
                        $('#wallet-id-label').html('Wallet ID');
                        $('#walletID').attr("placeholder", "Wallet ID");
                    $('#ntn').prop('required',false);
                        $('#ntn-label').html('NTN');
                        $('#ntn').attr("placeholder", "NTN");
                } else if(this.form.company_account_type == 'CORPORATE') {
                    if(this.form.payment_engine == 'FINCA') {
                        $('#ntn').prop('required',false);
                            $('#ntn-label').html('NTN');
                            $('#ntn').attr("placeholder", "NTN");
                        $('#walletID').prop('required',true);
                            $('#wallet-id-label').html('Wallet ID *');
                            $('#walletID').attr("placeholder", "Wallet ID *");
                    } else if (this.form.payment_engine == 'MEEZAN') {
                        $('#walletID').prop('required',true);
                            $('#wallet-id-label').html('Wallet ID *');
                            $('#walletID').attr("placeholder", "Wallet ID *");
                        $('#ntn').prop('required',true);
                            $('#ntn-label').html('NTN *');
                            $('#ntn').attr("placeholder", "NTN *");
                    }
                } else {
                    $('#walletID').prop('required',false);
                        $('#wallet-id-label').html('Wallet ID');
                        $('#walletID').attr("placeholder", "Wallet ID");
                    $('#ntn').prop('required',false);
                        $('#ntn-label').html('NTN');
                        $('#ntn').attr("placeholder", "NTN");
                }
            },
            getAccountTypeFields(){
                axios.get('/api/getCompanyAccountTypes').then(response => {
                    this.accountTypes = response.data.data;
                    this.selectPickerOnchange();
                }).catch(error => {
                    this.showAlertBox('error', 'Error to load Account Types data');
                });
            },
            selectPickerOnchange() {
                const select = this.$el;
                setTimeout(() => {
                    $(select).find('.selectpicker').selectpicker('refresh');
                }, 0);
            },
        },
        mounted() {
            this.$Progress.start();
            this.crud_company = true;
            this.getOnboardingCompanyPreData();
            this.getOnboardSources();
            if(typeof(this.$route.params.id) != "undefined" && this.$route.params.id !== null) {
                this.companyId = this.$route.params.id;
                this.form.companyId = this.$route.params.id;
                this.getOnboardUserDetails();
            }
            this.$Progress.finish();
            this.getAccountTypeFields();
            // this.can('crud_company').then(result => {
            //     this.crud_company = result.crud_company;
            // }).then(result => {
            //     if(this.crud_company == true){
			// 		// this.getAddCompanyData();
			// 		this.getOnboardingCompanyPreData();
            //         this.$Progress.finish();
            //     }else{
            //         this.$Progress.finish();
            //     }
            // });
        },
    }
</script>
